import './index.erb';
import './index.rb';
import './images/balls.svg';

import FormForUser from 'utils/form_for_user';

(() => {
  new FormForUser(
    '#js-blog-form',
    '#js-blog-form-default',
    '#js-blog-form-success',
    'blog newsletter subscribed');
})();
